module.exports = __webpack_public_path__ + "d6e750bfa55cbfdd0b19882b1e79fa0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sm-420.jpg
// module id = 536
// module chunks = 0